module.exports = (router) => {
    router.map({
        '/terms': {
            component: require('./components/Index.vue'),
            name: 'terms'
        },
        '/terms/:alias': {
            component: require('./components/Index.vue'),
            name: 'terms-by-alias'
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/routes/terms/router.js